module.exports = __webpack_public_path__ + "static/media/games.1f83a187.svg";